import React from 'react';
import TabContainer from '../../../../../../common/components/tab/containers/tab.containers';
import MediaInfoComponent from '../../../../../../common/components/common/media-info.component';
import IncludeComponent from '../../../../../../common/components/common/include.component';
import ExcludeComponent from '../../../../../../common/components/common/exclude.component';
import ServiceabilityBasicInfoComponent from './serviceability-basic-info.component';
import ServiceabilityValuesComponent from './serviceabilities-info.component';


export const ServiceabilityComponent = ({ getSubCategories, variants, productTypes, subCategories, pinCodes, selectedServiceabilityValues, handleFormServiceabilityItemChange, customers, products, allTags, categories, onInnerFormChange, id, fileTypes, mediaFiles, handleFormMediaItemChange, changeImage, selectedServiceabilitys, onInnerBasicFormChange, vendors, shippingType, back, handleFormSubmit }: any) => {
  const tabItems = [
    {
      id: 1,
      title: 'Basic-Info',
      component: (
        <ServiceabilityBasicInfoComponent
          vendors={vendors}
          onInnerBasicFormChange={onInnerBasicFormChange}
          selectedServiceabilitys={selectedServiceabilitys}
        />
      ),
      isVisible: true,
    },
    {
      id: 2,
      title: 'Include Entity',
      component: <IncludeComponent
        allTags={allTags}
        isSaleChannel={true}
        isCustomerTag={true}
        isCustomer={true}
        isStore={true}
        isWarehouse={true}
        isState={true}
        isCountry={true}
        customers={customers}
        handleInnerFormChange={onInnerFormChange}
        selectedInclude={selectedServiceabilitys}
      />,
      isVisible: true,
    },

    {
      id: 3,
      title: 'Exclude Entity',
      component: <ExcludeComponent
        isSaleChannel={true}
        isCustomerTag={true}
        isCustomer={true}
        isStore={true}
        isWarehouse={true}
        isState={true}
        isCountry={true}
        allTags={allTags}
        customers={customers}
        handleInnerFormChange={onInnerFormChange}
        selectedExclude={selectedServiceabilitys}
      />,
      isVisible: true,
    },
    {
      id: 4,
      title: 'Media',
      component:
        <MediaInfoComponent
          changeImage={changeImage}
          // deleteSelectedProduct={deleteSelectedCategory}
          fileTypes={fileTypes}
          //handleClose={handleClose}
          //handleOpen={handleOpen}
          onFormItemChange={handleFormMediaItemChange}
          // openConfirmation={openConfirmation}
          mediaFiles={mediaFiles}
        //uploadToDigiiFolder={uploadToDigiiFolder}
        />,
      isVisible: id > 0 ? true : false,
    },
    {
      id: 5,
      title: 'Serviceabilitys',
      component:
        <ServiceabilityValuesComponent
          selectedServiceabilityValues={selectedServiceabilityValues}
          onInnerBasicFormChange={onInnerBasicFormChange}
          selectedServiceabilitys={selectedServiceabilitys}
          onFormServiceabilityItemChange={handleFormServiceabilityItemChange}
          categories={categories}
          subCategories={subCategories}
          products={products}
          productTypes={productTypes}
          variants={variants}
          pinCodes={pinCodes}
          getSubCategories={getSubCategories}
        />,
      isVisible: true,
    },
  ]

  return (
    <div className="flex flex-col items-center w-full px-5 overflow-auto h-auto pb-20">


      <TabContainer tabItems={tabItems} />

      <div className='flex w-full justify-end items-end h-20'>
        <button
          onClick={back}
          type='button'
          className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
        >
          Back
        </button>
        <button
          className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
          onClick={handleFormSubmit}

          type="submit"
        >
          Save
        </button>
      </div>
    </div>
  )
}
export default ServiceabilityComponent;
